import React from 'react';
import { Card, CardContent, CardHeader, Chip, Grid, Link, Typography, Divider } from '@material-ui/core';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Entity } from '@backstage/catalog-model';

function getEntityDisplayName(entity: Entity): string {
  // Prefer title, then metadata.name
  return (entity.metadata.title || entity.metadata.name || 'Untitled').toString();
}

function getEntityDescription(entity: Entity): string | undefined {
  const d = entity.metadata.description;
  return typeof d === 'string' && d.trim().length ? d : undefined;
}

function getStringArray(value: unknown): string[] {
  return Array.isArray(value) ? value.filter(v => typeof v === 'string') as string[] : [];
}

type LinkItem = { url: string; title?: string; icon?: string };

function getLinks(entity: Entity): LinkItem[] {
  // Backstage commonly uses metadata.links: [{ url, title, icon }]
  const links = (entity.metadata as any)?.links;
  if (!Array.isArray(links)) return [];
  return links
    .filter(l => l && typeof l.url === 'string')
    .map(l => ({ url: l.url, title: l.title, icon: l.icon }));
}

export const SystemAboutCard: React.FC<{ variant?: 'gridItem' | 'fullHeight' | 'default' }> = () => {
  const { entity } = useEntity();

  const name = getEntityDisplayName(entity);
  const description = getEntityDescription(entity);
  const lifecycle = (entity.spec as any)?.lifecycle as string | undefined;
  const tags = getStringArray(entity.metadata.tags);
  const links = getLinks(entity);

  return (
    <Card>
      <CardHeader title="About" />
      <CardContent>
        {/* <hr/> */}
        <Divider style={{ margin: '16px 0' }} />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <h4 style={{ marginTop: 0 }}>Description</h4>
            {description && (
              <Typography variant="body2" color="textSecondary">
                {description}
              </Typography>
            )}
          </Grid>
{/* 
          {lifecycle && (
            <Grid item xs={12}>
              <Typography variant="subtitle2">Lifecycle</Typography>
              <Typography variant="body2">{lifecycle}</Typography>
            </Grid>
          )} */}

          {/* {tags.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="subtitle2">Tags</Typography>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
                {tags.map(t => (
                  <Chip key={t} size="small" label={t} />
                ))}
              </div>
            </Grid>
          )}

          {links.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="subtitle2">Links</Typography>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 6 }}>
                {links.map(l => (
                  <Link key={l.url} href={l.url} target="_blank" rel="noopener noreferrer">
                    {l.title || l.url}
                  </Link>
                ))}
              </div>
            </Grid>
          )} */}
        </Grid>
      </CardContent>
    </Card>
  );
};
